// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import $$Image from "next/legacy/image";
import * as CityContext$PorterinFeature from "../../contexts/city-context/CityContext.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../shared/core/helpers/PublishEventsHelper.mjs";

function NextImage(Props) {
  var src = Props.src;
  var height = Props.height;
  var width = Props.width;
  var qualityOpt = Props.quality;
  var alt = Props.alt;
  var fallbackSrc = Props.fallbackSrc;
  var priorityOpt = Props.priority;
  var layout = Props.layout;
  var className = Props.className;
  var quality = qualityOpt !== undefined ? qualityOpt : 75.0;
  var priority = priorityOpt !== undefined ? priorityOpt : false;
  var match = React.useState(function () {
        return src;
      });
  var setImgSrc = match[1];
  var city_context = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var tmp = {
    alt: alt,
    priority: priority,
    quality: quality,
    src: match[0],
    onError: (function (param) {
        PublishEventsHelper$PorterinFeature.publishEvents(city_context.category, "Image Broken", "Image Broken at: " + alt);
        if (fallbackSrc !== undefined) {
          return Curry._1(setImgSrc, (function (param) {
                        return fallbackSrc;
                      }));
        } else {
          return Curry._1(setImgSrc, (function (param) {
                        return "";
                      }));
        }
      })
  };
  if (className !== undefined) {
    tmp.className = className;
  }
  if (height !== undefined) {
    tmp.height = height;
  }
  if (layout !== undefined) {
    tmp.layout = Caml_option.valFromOption(layout);
  }
  if (width !== undefined) {
    tmp.width = width;
  }
  return React.createElement($$Image, tmp);
}

var $$Image$1;

var make = NextImage;

export {
  $$Image$1 as $$Image,
  make ,
}
/* react Not a pure module */
